/**
 * @generated SignedSource<<5e3744baa56592241aa8051b0c2ab009>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type queryAgentMentionsFragment$data = {
  readonly description: string | null;
  readonly id: string;
  readonly identityAccount: {
    readonly picture: AGG$URL;
  } | null;
  readonly identityAccountId: string | null;
  readonly name: string | null;
  readonly " $fragmentType": "queryAgentMentionsFragment";
};
export type queryAgentMentionsFragment$key = {
  readonly " $data"?: queryAgentMentionsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"queryAgentMentionsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "queryAgentMentionsFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "LinkedField",
      "name": "identityAccount",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "picture"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "identityAccountId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ],
  "type": "AgentStudioAssistant"
};

(node as any).hash = "c9fe20126b9ae533caed55eab71ee09d";

export default node;
